<template>
  <p class="fz-18 text-white" style="line-height: 1.875rem;">
    {{text}}
  </p>
</template>

<script>
export default {
  name: "textElement",
  props: ['text']
}
</script>

<style scoped>

</style>